import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';

export const PostCardWrapper = styled.a`
  display: flex;
  flex-direction: column;
  border: 1px solid #d2d5da;
  border-radius: 3px;

  &:hover,
  &:focus {
    .title {
      text-decoration-line: underline;
    }
  }

  @media (${mediaQuery.tablet}) {
    flex-direction: row;
    border: none;
    height: 125px;
  }

  @media (${mediaQuery.mobile}) {
    height: 110px;
  }
`;

export const PostCardImage = styled.div`
  height: 200px;
  width: 100%;
  background-color: #f3f4f6;
  overflow: hidden;
  flex-shrink: 0;
  position: relative;
  border-radius: 3px 3px 0 0;

  .lazy-image-wrapper {
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .play-icon-wrapper {
    width: 55px;
    height: 55px;
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  @media (${mediaQuery.tablet}) {
    width: 224px;
    height: 100%;
    border-radius: 3px;
  }

  @media (${mediaQuery.mobile}) {
    width: 146px;
  }
`;

export const PostCardBody = styled.div`
  flex-direction: column;
  padding: 16px;
  position: relative;
  height: 156px;

  @media (${mediaQuery.tablet}) {
    flex-grow: 1;
    padding: 0 0 0 12px;
    height: auto;
  }

  .category-tag {
    font-size: 14px;
    font-weight: 300;
    line-height: 14px;
    color: #697684;

    @media (${mediaQuery.mobile}) {
      font-size: 12px;
      line-height: 12px;
    }
  }

  .title {
    --lh: 26px;
    --max-lines: 3;
    font-size: 18px;
    font-weight: 400;
    line-height: var(--lh);
    color: #333f48;
    height: calc(var(--lh) * var(--max-lines));
    margin-top: 8px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: var(--max-lines);
    overflow: hidden;

    @media (${mediaQuery.tablet}) {
      --max-lines: 2;
      -webkit-line-clamp: var(--max-lines);
      margin-top: 8px;
    }

    @media (${mediaQuery.mobile}) {
      --lh: 22px;
      --max-lines: 3;
      font-weight: 400;
      -webkit-line-clamp: var(--max-lines);
      font-size: 16px;
      margin-top: 4px;
    }
  }

  .footer {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #697684;
    position: absolute;
    bottom: 16px;

    @media (${mediaQuery.tablet}) {
      align-self: flex-end;
      font-size: 12px;
      margin-top: 8px;
      bottom: 0;
    }

    .author-name {
      @media (${mediaQuery.tablet}) {
        font-size: 14px;
      }
      @media (${mediaQuery.mobile}) {
        font-size: 12px;
      }
    }
  }
`;
